/** "Cabos e Carregadores › Cabos V8" na subcategoria; o nome, na de cima. */
export const categoryLabel = (category: {
  readonly name: string
  readonly parentName?: string | null | undefined
}): string =>
  category.parentName === null || category.parentName === undefined
    ? category.name
    : `${category.parentName} › ${category.name}`
